<template>
  <div class="wrap">
        <h3>1.什么是云存档？</h3>
        <p class="pro">云存档可以将您的游戏存档上传到服务器中保存，即使您删除游戏，只要重装游戏后登录233账号，将存档下载到本地即可继续游戏</p>
        <h3>2.上传云存档</h3>
        <p class="pro">每日首次打开233，均会自动将本地存档上传至服务器。您也可如下图在云存档界面手动上传云存档。</p>
        <div class="picshow">
            <img class="imgtype1" src="~assets/images/clickbtn.png" alt="">
            <img style="width: 40px;height:40px;" src="~assets/images/right.png" alt="">
            <img class="imgtype1" src="~assets/images/clickup.png" alt="">
        </div>
        <h3>3.下载云存档</h3>
        <p class="pro">若您的账号拥有某游戏的云存档，则当您安装该游戏时，会提示您进行下载。您也可如下图在云存档界面手动下载云存档</p>
        <div class="picshow">
            <img class="imgtype1" src="~assets/images/clickbtn.png" alt="">
            <img style="width: 40px;height:40px;" src="~assets/images/right.png" alt="">
            <img class="imgtype1" src="~assets/images/clickdown.png" alt="">
        </div>   
        <h3>4.哪些游戏可用云存档</h3>
        <p class="pro">如下图，凡是在“开始游戏”按钮左侧有“云存档”按钮的游戏均支持云存档功能。更多支持云存档的游戏正在开发中，敬请期待~</p>
        <img class="bottomimg" src="~assets/images/actionstart.png" alt="">
        <h3>5.下载云存档后无效或无法打开游戏</h3>
        <p class="pro">若您在下载云存档后无法打开游戏，或存档未生效，请尝试重新安装游戏后再次下载存档。若仍然无效，请联系客服<a href="#" onclick="Android.openCustomerService()"><i>点我联系客服</i></a></p>
    </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less">
.wrap{
    width: 100%;
    font-size:16px;
}
h3{
    margin-top: 10px;
    margin-left: 10px;
    font-weight:bold;
    font-size:18.72px;
}
.pro{
    padding:5px 20px;
}
.picshow{
    width: 90%;
    margin: 0 5%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.picshow .imgtype1{
    width:150px;
}
.bottomimg{
    width: 90%;
    margin:0 5%;
}
p{
  color:#000;
}
</style>